import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'lum-rfq-quantity-form',
  templateUrl: './rfq-quantity-form.component.html',
  styleUrls: ['./rfq-quantity-form.component.scss'],
})
export class RfqQuantityFormComponent implements OnInit {
  form :UntypedFormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data :any,
    private fb :UntypedFormBuilder,
    private dialogRef :MatDialogRef<RfqQuantityFormComponent>,
  ) {}

  ngOnInit() :void {
    this.initForm();
  }

  onSubmit() :void {
    this.dialogRef.close(this.form.value);
  }

  private initForm() :void {
    this.form = this.fb.group({
      quantity: [0, Validators.required],
    });
  }
}
